export const E4K_GAME_ID = 16

export const TED_MOBILE_BROWSER_SHOP = 1272
export const RANCH_WEB_SHOP_CALL = 1181

export const SOURCE_ID = 'MBS'

export const LINKS = {
    terms: 'http://www.goodgamestudios.com/terms_{{lang}}/#terms',
    legal: 'https://www.goodgamestudios.com/terms_{{lang}}/#imprint',
    support: 'https://support.goodgamestudios.com/',
    getTermsLink(lang: string) {
        return this.terms.replace('{{lang}}', lang)
    },
    getLegalLink(lang: string) {
        return this.legal.replace('{{lang}}', lang)
    },
    getSupportLink(lang: string, gameId: number) {
        return `${this.support}?lang=${lang}&g=${gameId}`
    },
}

export const actionsType = {
    PAGE_LOADED: 0,
    WRONG_CODE_ENTRY: 1,
    CORRECT_CODE_ENTRY: 2,
    CORRECT_CODE_ENTRY_BANNED: 3,
    ERROR_RESPONSE: 4,
} as const

type actionType = typeof actionsType
export type ActionsType = actionType[keyof actionType]

export type TrackingPayloadMBS = {
    eventId: number // Tracking Event Definition (TED)
    actionType: ActionsType
    microtime: number
    date: string
    zoneId?: number
    gameId?: number
    isAutoLoggedIn?: number
    networkId?: number
    instanceId?: number
    playerId?: number
    sessionId?: string
}

export type TrackingPayloadRanch = {
    sourceId: string
    eventId: number // Tracking Event Definition (TED)
    microtime: number
    date: string
    zoneId?: number
    gameId?: number
    networkId?: number
    instanceId?: number
    playerId?: number
    sessionId?: string
    unixtimeMS: number
}

export type PlayerInfo = {
    level: number
    legendLevel: number
}

export type MbsSessionData = {
    playerName: string
    zoneId: string
    criteria: string // stringifyed PlayerInfo
    sid: string
    gameId: number
    networkId: number
    instanceId: number
    playerId: number
    isTempserver: boolean
}

export type JWTTokenPayload = {
    gameId: number
    networkId: number
    instanceId: number
    playerId: number
    zoneId: string
    preferred_username: string
    playerInfo: PlayerInfo
    criteria: string
    sid: string
    sub: string
    iss: string
    aud: string
    iat: number
    exp: number
}
